<template>
  <div class="step">
    <h2 class="step__title">{{ title }}</h2>

    <div class="step__list" :class="{'step__list--many': options.length >=10}">
      <label v-for="(i, index) in options" class="step__item">
        <input class="step__radio visually-hidden" type="radio" name="zodiak" v-model="val" :value="index" @change="$emit('change', options[val])">
        <span class="step__label">{{ i.title }}</span>
      </label>
    </div>

    <button v-if="index !== 0" class="step__btn" @click="$emit('goPrev')"><span class="visually-hidden">Назад</span></button>

  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    title: {
      type: String
    },
    options: {
      type: Array
    },
    index: {
      type: Number
    }
  },

  data() {
    return {
      value: '',
      val: ''
    }
  },

  watch: {
    async options() {
      await this.$nextTick()
      this.val = null
    }
  }
}
</script>
